module.exports = __webpack_public_path__ + "img/marquee-icon.77e2d97c.png";